import inView from 'in-view'
// import moduleLoading from '../components/common/loading/module-loading'
import utils from './utils'

import isIOS from './isIOS'

export default function install(Vue) {
  function funcFocus(el, binding) {
    ;[...document.querySelectorAll(`.${binding.expression}`)].forEach(ele => {
      ele.style.position = 'static'
    })
  }
  function funcBlur(el, binding) {
    ;[...document.querySelectorAll(`.${binding.expression}`)].forEach(ele => {
      ele.style.position = ''
    })
  }
  // 软键盘顶起问题
  Vue.directive('focus', {
    bind(el, binding) {
      el.addEventListener('focus', () => funcFocus(el, binding))
      el.addEventListener('blur', () => funcBlur(el, binding))
    },
    unbind(el, binding) {
      el.removeEventListener('focus', () => funcFocus(el, binding))
      el.removeEventListener('blur', () => funcBlur(el, binding))
    }
  })
  // 富文本图片压缩
  Vue.directive('xhtml', (el, binding) => {
    const value = binding.value
    const ele = document.createElement('div')
    ele.innerHTML = value
    ;[...ele.querySelectorAll('img')].forEach(img => {
      if (/http|https/.test(img.src)) {
        img.src = utils.viewImage(img.src)
      }
    })
    el.innerHTML = ele.innerHTML
  })
  Vue.directive('highlight', (el, binding) => {
    const searchValue = binding.value.searchValue
    const oldValue = binding.value.oldValue
    const target = `<em>${searchValue}</em>`
    if (oldValue) {
      el.innerHTML = oldValue.replace(new RegExp(searchValue, 'gm'), target)
    } else {
      el.innerHTML = binding.value.oldValue
    }
  })
  Vue.directive('scroll', {
    bind(el, binding, vnode) {
      el.vm = {
        distance: el.getAttribute('scroll-distance'),
        scrollTop: 0,
        direction: 'down'
      }
      function scroll(x, y) {
        const scrollTop = window.scrollY || document.body.scrollTop
        el.vm.direction = el.vm.scrollTop > scrollTop ? 'down' : 'up'
        el.vm.scrollTop = scrollTop
        if (!inView.is(el) || el.vm.direction === 'down') return
        const done =
          document.body.scrollHeight - scrollTop <=
          document.body.offsetHeight + (Number(el.vm.distance) || 40)
        if (!done || typeof binding.value !== 'function') return
        binding.value()
      }
      window.addEventListener('scroll', scroll)
    },
    inserted(el, binding, vnode) {
      el.vm.scrollTop = window.scrollY || document.body.scrollTop
      const distance = el.vm.distance
      function scroll() {
        if (!inView.is(el)) return
        // if (el.offsetHeight > document.body.offsetHeight && typeof binding.value === 'function') {
        //     binding.value()
        //     return
        // }
        if (
          document.body.scrollHeight >= document.body.offsetHeight ||
          typeof binding.value !== 'function'
        )
          return
        binding.value()
      }
      scroll()
    }
  })
  // Vue.directive('loading', {
  //     bind(el, binding) {
  //         const Loading = Vue.extend(moduleLoading)
  //         const ele = new Loading({
  //             el: document.createElement('div')
  //         })
  //         el.appendChild(ele.$el);
  //         binding.loadingBox = ele.$el
  //     },
  //     update(value) {
  //     }
  // })
  function toScrollBack() {
    try {
      setTimeout(() => {
        if (
          document.activeElement.tagName !== 'INPUT' &&
          document.activeElement.tagName !== 'TEXTAREA'
        ) {
          if (isIOS) {
            let scrollHeight =
              document.documentElement.scrollTop || document.body.scrollTop || 0
            window.scrollTo(0, Math.max(scrollHeight - 1, 0))
          }
        }
      })
    } catch (e) {
      console.log(e)
    }
  }
  Vue.directive('inputScroll', {
    bind(el) {
      el.addEventListener('blur', toScrollBack)
    },
    unbind(el) {
      el.removeEventListener('blur', toScrollBack)
    }
  })
  /* 
        图片预览组件van-image-preview全屏显示时，会给body增加overflow: hidden;的样式，组织背景滚动，
        而vproduct里body全局设置了height: 100%;这会导致内容超出一屏时滚动条自动置顶，
        这个指令用于全屏显示前记录下滚动条位置，关闭时再恢复滚动条位置，
        由于update会发生body增加样式之后，所以在使用时需加一个额外div来提前记录。
    */
  Vue.directive('van-image-preview-scroll-fix', {
    update(el, binding) {
      const show = binding.value
      if (show) {
        if (window._tempScrollY == null) {
          window._tempScrollY = window.scrollY
        }
      } else {
        setTimeout(() => {
          if (window._tempScrollY) {
            window.scrollTo(0, window._tempScrollY)
            window._tempScrollY = null
          }
        }, 50)
      }
    }
  })
}

window._tempScrollY = null
